import React from 'react';
const About = () => {
  return (
    <div className="max-w-7xl mx-auto px-6 py-12 bg-gray-50 flex flex-col items-center justify-center">
      <h1 className="text-2xl font-bold text-center mb-6 text-blue-600">
        About Officialbillboard
      </h1>
      <p className="text-lg text-center mb-8">
        Your premier crypto investment platform with over <strong>5 years of experience</strong> in navigating the dynamic world of cryptocurrency. Based in the vibrant tech hub of <strong>Austin, Texas</strong>, we specialize in empowering investors through innovative strategies tailored to maximize returns and minimize risks.
      </p>

      <h2 className="text-2xl font-semibold text-blue-500 mb-4">🌟 Our Mission</h2>
      <p className="mb-6">
        At officialbillboard, we are dedicated to providing you with the tools and insights necessary to thrive in the evolving landscape of digital assets.
      </p>

      <h2 className="text-2xl font-semibold text-blue-500 mb-4">🚀 Why Choose Us?</h2>
      <ul className="list-disc list-inside mb-6 space-y-2">
        <li><strong>Proven Expertise:</strong> Our team of analysts employs cutting-edge strategies to ensure you achieve your financial goals.</li>
        <li><strong>Diverse Strategies:</strong> From long-term holds to active trading, we tailor our approach to meet your unique risk appetite.</li>
        <li><strong>User-Friendly Platform:</strong> Monitor your investments in real-time with our intuitive interface.</li>
        <li><strong>Comprehensive Resources:</strong> Access our extensive library of educational resources and market analyses.</li>
      </ul>

      <h2 className="text-2xl font-semibold text-blue-500 mb-4">🔍 Our Approach</h2>
      <ol className="list-decimal list-inside mb-6 space-y-2">
        <li><strong>Research-Driven:</strong> We conduct in-depth market analysis to identify trends and opportunities.</li>
        <li><strong>Community-Focused:</strong> Engage with like-minded investors and gain insights from our forum.</li>
        <li><strong>Robust Security:</strong> We implement top-tier security measures to protect your assets and personal information.</li>
      </ol>

      <h2 className="text-2xl font-semibold text-blue-500 mb-4">💬 Join Us</h2>
      <p className="mb-6">
        Embark on your crypto investment journey with Officialbillboard. Whether you're looking to diversify your portfolio or dive into the world of digital currencies for the first time, our expert guidance will help you navigate this exciting landscape.
      </p>

      <h2 className="text-2xl font-semibold text-blue-500 mb-4">📈 Let’s Connect</h2>
      <p className="mb-6">
        Discover the future of investing with Officialbillboard. Visit our platform today and take the first step toward financial empowerment!
      </p>

      <div className="text-center">
        <a 
          href="mailto:support.officialbillboard@officialbillboard.com" 
          className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg shadow hover:bg-blue-700 transition duration-200">
          Contact Us
        </a>
      </div>
      
      <div className="mt-10 text-center">
        <p className="text-gray-600">
          Officialbillboard — where insight meets opportunity.
        </p>
      </div>
    </div>
  );
};
export default About;

